{
  "qr-checkin-config-page": {
    "buttons": {
      "check-in": "CHECK IN"
    },
    "meta": {
      "title": "QR Check in",
      "description": "Check in par code QR",
      "checkin-hint": "(Facultatif) Vous pouvez choisir votre service avant check-in"
    }
  }
}
